import Logo from "../../logo/Logo";
import navData from "./data";
import { useLocation, Link } from "react-router-dom";
import messageQuestion from "../../../assets/message-question.png";

const SideNav = () => {
  const location = useLocation();
  return (
    <div className="hidden lg:block fixed w-[266px] h-screen border-r border-layoutDemarcation pt-9 pb-[31px] pl-5 pr-5 font-Inter">
      <Logo />
      <nav className="mt-10">
        <ul>
          {navData.map(({ name, route, iconActive, iconInactive }) => (
            <Link to={route} key={route}>
              <li className="flex gap-3 items-center mt-5 h-[44px]">
                {location.pathname === route ? (
                  <img src={iconActive} alt="icon" />
                ) : (
                  <img src={iconInactive} alt="icon" />
                )}
                <p
                  className={`font-medium text-sm ${
                    location.pathname === route
                      ? "text-sidenavActive"
                      : "text-sidenavInactive"
                  }`}
                >
                  {name}
                </p>
              </li>
            </Link>
          ))}
        </ul>
      </nav>

      <button className="w-[226px] absolute bottom-[31px] h-[61px] bg-[#F8F9FF] p-[10px] rounded-lg flex gap-3 items-center">
        <div className="w-[40px] h-[40px] bg-sidenavActive rounded-full flex justify-center items-center">
          <img src={messageQuestion} alt="support" />
        </div>
        <p className="text-sidenavInactive font-medium">Need Support?</p>
      </button>
    </div>
  );
};

export default SideNav;
